import { create_ssr_component } from "svelte/internal";
const Index = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return ``;
});
export {
  Index as default
};
